(function () {
  if (window.__superpromoBadgeInitialized) return;
  window.__superpromoBadgeInitialized = true;

  function parseNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function pluralize(count, singular, plural) {
    return count === 1 ? singular : plural;
  }

  function normalizeCode(value) {
    return String(value || '').trim().toUpperCase();
  }

  function parseCodeList(value) {
    return String(value || '')
      .split(',')
      .map(normalizeCode)
      .filter(Boolean);
  }

  function isTrue(value) {
    return String(value || '').toLowerCase() === 'true';
  }

  function getCurrentTier(count, goals) {
    if (count >= goals.t20) return 20;
    return 0;
  }

  function buildMessage(count, tier, goals) {
    if (count >= goals.t20) {
      return '¡Ya desbloqueaste 20% OFF! Tu carrito alcanzó la promoción.';
    }

    if (count === 1) {
      return 'Te falta 1 producto para aplicar tu descuento.';
    }

    return 'Agrega 2 productos para aplicar tu descuento.';
  }

  function getScopeBlock(root) {
    return root || document;
  }

  function getCartText(root) {
    return normalizeCode(getScopeBlock(root).textContent);
  } 

  function hasTestDiscountCode(block, root) {
    var testCodes = parseCodeList(block.getAttribute('data-superpromo-test-codes'));
    if (!testCodes.length) return false;

    var liquidDiscounts = parseCodeList(block.getAttribute('data-superpromo-active-discounts'));
    if (liquidDiscounts.some(function (code) { return testCodes.indexOf(code) !== -1; })) {
      return true;
    }

    var cartText = getCartText(root);
    return testCodes.some(function (code) {
      return cartText.indexOf(code) !== -1;
    });
  }

  function shouldShowBadge(block, root) {
    if (isTrue(block.getAttribute('data-superpromo-shop-active'))) return true;
    return hasTestDiscountCode(block, root);
  }

  function setBadgeVisibility(block, isVisible) {
    block.hidden = !isVisible;
    block.classList.toggle('superpromo-badge--hidden', !isVisible);
  }

function calculatePromoCount(scope, nonPromoIds) {
    var total = 0;
    var items = getScopeBlock(scope).querySelectorAll('[data-cart-item]');

    // Diccionario de IDs de Perú
    var peruKitIds = {
      "8294624723119": 2, // Duo Revitalizante
      "8236050645167": 2, // Dúo Efecto Detox
      "8235947425967": 2, // Dúo Efecto Tropical
      "8089976537263": 2, // Dúo de perfumes capilares
      "8089976012975": 2  // Kit B8 Liso Perfecto
    };

    items.forEach(function (item) {
      var htmlContent = String(item.innerHTML || '').toLowerCase();
      var productId = String(item.getAttribute('data-pid') || '').trim();
      
      if (productId && nonPromoIds.has(productId)) return;

      // 1. Lo que dice el HTML (está devolviendo 1 por defecto)
      var htmlKitQty = parseNumber(item.getAttribute('data-item-kit-qty'), 0);

      // 2. Lo que dice nuestro diccionario
      var mapKitQty = peruKitIds[productId] || 0;

      // 3. Lo que dice el nombre del producto
      var isDuoOrKit = htmlContent.indexOf('duo') !== -1 ||
                       htmlContent.indexOf('dúo') !== -1 ||
                       htmlContent.indexOf('kit') !== -1;
      var textKitQty = isDuoOrKit ? 2 : 1;

      // LA MAGIA: Calculamos el máximo entre todas las opciones
      var kitQty = Math.max(htmlKitQty, mapKitQty, textKitQty, 1);

      var qtyInput = item.querySelector('input[name="updates[]"], input[type="number"]');
      var quantity = qtyInput ? parseNumber(qtyInput.value || qtyInput.getAttribute('data-current-qty'), 1) : 1;
      
      total += Math.max(quantity, 0) * kitQty;
    });

    return total;
  }
  
  function updateBadge(block) {
    var root = block.closest('[data-cart-wrapper]') || block.closest('[data-cart-content]') || document;
    var isVisible = shouldShowBadge(block, root);

    setBadgeVisibility(block, isVisible);

    if (!isVisible) return;

    var goals = {
      t20: parseNumber(block.getAttribute('data-superpromo-goal-20'), 2),
      max: parseNumber(block.getAttribute('data-superpromo-goal'), 2)
    };
    var nonPromoIds = new Set(String(block.getAttribute('data-superpromo-non-promo-ids') || '').split(',').map(function (value) {
      return value.trim();
    }).filter(Boolean));
    var count = calculatePromoCount(root, nonPromoIds);
    var tier = getCurrentTier(count, goals);
    var progress = Math.min((count / Math.max(goals.max, 1)) * 100, 100);

    var titleEl = block.querySelector('[data-superpromo-title]');
    var message = block.querySelector('[data-superpromo-message]');
    var progressFill = block.querySelector('[data-superpromo-progress]');
    var countEl = block.querySelector('[data-superpromo-count]');
    var tierEl = block.querySelector('[data-superpromo-tier]');

    if (titleEl) titleEl.textContent = tier >= 20 ? '¡20% OFF desbloqueado!' : 'Desbloquea 20% OFF';
    if (message) message.textContent = buildMessage(count, tier, goals);
    if (progressFill) progressFill.style.width = progress + '%';
    if (countEl) countEl.textContent = count + ' ' + pluralize(count, 'producto', 'productos');
    if (tierEl) tierEl.textContent = tier + '% OFF actual';

    block.setAttribute('data-tier', String(tier));

    var marks = block.querySelectorAll('[data-superpromo-mark]');
    marks.forEach(function (mark) {
      var markTier = parseNumber(mark.getAttribute('data-superpromo-mark'), 0);
      var isActive = tier >= markTier;
      mark.classList.toggle('superpromo-badge__progress-mark--active', isActive);
      mark.style.color = isActive ? '#d6336c' : '';
      mark.style.fontWeight = isActive ? '700' : '';
    });
  }

  function updateAllBadges() {
    document.querySelectorAll('[data-superpromo-badge]').forEach(updateBadge);
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateAllBadges();

    /* Re-run when cart items appear after initial render (AJAX / lazy) */
    var cartWrapper = document.querySelector('[data-cart-wrapper]');
    if (cartWrapper) {
      var observer = new MutationObserver(function () {
        setTimeout(updateAllBadges, 100);
      });
      observer.observe(cartWrapper, { childList: true, subtree: true });
    }
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-superpromo-toggle]');
    if (!toggle) return;
    var badge = toggle.closest('[data-superpromo-badge]');
    if (badge) badge.classList.toggle('superpromo-badge--open');
  });

  if (window.jQuery_T4NT) {
    jQuery_T4NT(document).on('cart:updated.superpromoBadge add:cart:success.superpromoBadge', function () {
      setTimeout(updateAllBadges, 150);
    });
  }

  if (window.FoxkitEvents && typeof window.FoxkitEvents.subscribe === 'function') {
    window.FoxkitEvents.subscribe('ON_FOXKIT_CART_UPDATE', function () {
      setTimeout(updateAllBadges, 150);
    });
  }

  window.SuperPromoBadge = window.SuperPromoBadge || { update: updateAllBadges };
})();